var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pacificblue", attrs: { id: "learnembed" } },
                [
                  _c("VueScriptComponent", {
                    attrs: {
                      script:
                        '<script type="text/javascript">        var user_id = 569732;var partner_id = 146;var client_id = 72389;var language_id = 1;</script><script id="course" charset="utf-8" src="https://poweredbyu.uinct.com/products/learn/embed/course/embed_course.js"></script>'
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "d-inline heading" }, [_vm._v("Course Display")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2604dc9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2604dc9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/course_render.vue
// module id = null
// module chunks = 